// Définition du type d’entrée pour FilterListNodeCheck
export interface FilterListNodeParams {
  id: string;
  naturalKey: string;
  referenceType: string;
  components: string[];
  isHierarchique: boolean;
  hierarchicalKey: string;
  __display_fr: string;
  __display_en: string;
  __display_default: string;
  parents?: FilterListNode[]; // Optionnel, par défaut []
}

export class FilterListNode {
  id: string;
  naturalKey: string;
  referenceType: string;
  hierarchicalKey: string;
  isHierarchique: boolean;
  components: string[];
  __display_fr: string;
  __display_en: string;
  __display_default: string;
  parents: FilterListNode[];

  constructor({
    id,
    naturalKey,
    referenceType,
    components,
    isHierarchique,
    hierarchicalKey,
    __display_fr,
    __display_en,
    __display_default,
    parents = [],
  }: FilterListNodeParams) {
    this.id = id;
    this.naturalKey = naturalKey;
    this.referenceType = referenceType;
    this.hierarchicalKey = hierarchicalKey;
    this.isHierarchique = isHierarchique;
    this.components = components;
    this.__display_fr = __display_fr;
    this.__display_en = __display_en;
    this.__display_default = __display_default;
    this.parents = parents;
  }

  /**
   * Retourne le parent au rang donné (0 = le plus haut)
   */
  getParent(rank: number): FilterListNode | undefined {
    return this.parents && rank >= 0 && rank < this.parents.length
      ? this.parents[rank]
      : undefined;
  }
}

export class FilterListLeaf extends FilterListNode {
  constructor(params: FilterListNodeParams) {
    super(params);
  }
}

export class FilterListParent extends FilterListNode {
  constructor(params: FilterListNodeParams) {
    super(params);
  }
}
